// extracted by mini-css-extract-plugin
export default {"helpText":"HelpText_helpText__RCjxq"};